import React from "react"
import { Redirect } from "react-router-dom"

const RedirectToHome = (props) => {
  return <Redirect to={{ pathname: "/", state: { from: props.location } }} />
}

export default RedirectToHome
